// Styles for __name__ go here.
import styled from 'styled-components';

export const StyledMapMarker = styled.div``;
